export default __webpack_public_path__ + "static/media/announcement-highlights-desktop-outer.9d9509fe.svg";